import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { SYS1020_R01Dto } from "./Dto_SYS1020_R01";
import { SYS1020_R01Filter } from "./Store_SYS1020_R01";

const baseUrl = `${config.apiUrl}/SYS1020_R01`;

export const getSYS1020_R01List = (
    option: "search" | "refetch",
    params: Partial<SYS1020_R01Filter>,
) => getData<ResponseDto<SYS1020_R01Dto[]>>(`${baseUrl}/${option}`, { params });

export const getSYS1020_R01AllCount = (params: Partial<SYS1020_R01Filter>) =>
    getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });

export const postSYS1020_R01 = (data: SYS1020_R01Dto[]) =>
    postData<SYS1020_R01Dto[], ResponseDto<SYS1020_R01Dto[]>>(baseUrl, data);

export const patchSYS1020_R01 = (data: SYS1020_R01Dto[]) =>
    patchData<SYS1020_R01Dto[], ResponseDto<SYS1020_R01Dto[]>>(baseUrl, data);

export const deleteSYS1020_R01 = (data: SYS1020_R01Dto) => {
    const messageType = encodeURIComponent(data.messageType);
    const messageSrc = encodeURIComponent(data.messageSrc);
    const messageCd = encodeURIComponent(data.messageCd);
    return deleteData<ResponseDto<void>>(`${baseUrl}/${messageType}/${messageSrc}/${messageCd}`);
};

export const downloadExcel_SYS1020_R01 = (params: Partial<SYS1020_R01Filter>) =>
    getData<ResponseDto<string>>(`${baseUrl}/excel/search`, { params });
